import React from 'react';

import * as Styled from './ClientLoyaltyInfo.styles';
import { clientInfoContent } from './content';

const ClientLoyaltyInfo: React.FC<{ updClientLoyaltyImg?: boolean }> = ({
  updClientLoyaltyImg,
}) => {
  return (
    <Styled.ClientLoyaltyInfoBlock>
      <div className="client-info-content">
        {clientInfoContent.map((item) => (
          <div className="client-info-item" key={item.title}>
            <h2>{item.title}</h2>
            <div className="actions">
              <p>{item.actionsTitle}</p>
              {item.actions.map((action) => (
                <div key={action}>{action}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <img
        src={`/images/loyalty-banner${
          updClientLoyaltyImg ? '-beeline' : ''
        }.png`}
        alt="banner"
      />
    </Styled.ClientLoyaltyInfoBlock>
  );
};

export default ClientLoyaltyInfo;
